<!-- 智能计划协同 -->
<template>
  <div>
    <avue-crud ref="crud" v-model="form" :option="option" :table-loading="loading" :data="data" :page.sync="page" :search.sync="query" :defaults.sync="defaults" @row-save="rowSave" @row-update="rowUpdate" @row-del="rowDel"
      @search-change="searchChange" @search-reset="searchReset" @refresh-change="refreshChange" :beforeOpen="beforeOpen" @current-change="currentChange" @size-change="sizeChange" @on-load="onLoad" @selection-change="selectionChange">
      <template slot="menuLeft">
        <el-button type="primary" size="small" plain icon="el-icon-download" :loading="exportLoading" @click="handleExport">导出</el-button>
      </template>
      <template slot="stockStatusName" slot-scope="{ row }">
        <el-tag :type="stockStatusType(row.stockStatusName)" size="small">{{ row.stockStatusName || '-' }}</el-tag>
      </template>
      <template slot="planReasonableName" slot-scope="{ row }">
        <el-tag :type="planReasonableType(row.planReasonableFlag)" size="small">
          {{ row.planReasonableName || planReasonableLabel(row.planReasonableFlag) || '-' }}
        </el-tag>
      </template>
    </avue-crud>
  </div>
</template>
<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, update, remove, getDetail, exportExcel } from "./api";
import { getSearchTimeConfig } from "@/basic-common/util/common";
import validator from "@/util/validate.js";
import { downloadXls } from '@/util/util'

export default {
  name: "store-management/index/index",
  mixins: [crudMixins],
  components: {},
  data () {
    const planReasonableDic = [
      { label: '正常', value: '0' },
      { label: '预警', value: '1' },
      { label: '严重冲突', value: '2' },
    ]
    return {
      apiConfig: { getList, update, remove, getDetail },
      exportLoading: false,
      planReasonableDic,
      defaultParams: {
        "businessType": "2", //必须传且为2 汽车出库
        "queryStock": "1", //是否查询库存必传 1查询
      },
      option: {
        ...this.$store.state.publicOption,
        addBtn: false,
        viewBtn: false,
        column: [
          {
            label: '计划编号',
            prop: 'planNo',
            rules: [
              { required: true, message: '请输入计划编号', trigger: 'blur' },
            ],
            maxlength: 32,
            disabled: true,
          },
          {
            label: '计划名称',
            prop: 'planName',
            width: 150,
            rules: [
              { required: true, message: '请输入计划名称', trigger: 'blur' },
            ],
            maxlength: 32,
          },
          {
            label: '客户',
            prop: 'custNo',
            overHidden: true, // 表格超出隐藏
            type: 'select',
            remote: true,
            dicUrl: '/api/produce/blade-dept/select/distinct/select',
            props: {
              label: 'deptName',
              value: 'id'
            },
            width: 150,
            search: true, // 查询是否显示
          },
          {
            label: '计划数量(吨)',
            prop: 'planTotalWeight',
            rules: [
              { required: false, trigger: "blur", validator: validator.positiveNum2 }
            ]
          },
          {
            label: '当前库存(吨)',
            prop: 'stockWeight',
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '合同编号',
            prop: 'contractNo',
            minWidth: 150,
            overHidden: true,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '合同名称',
            prop: 'contractName',
            minWidth: 150,
            overHidden: true,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '库存状态',
            prop: 'stockStatusName',
            minWidth: 100,
            slot: true,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '合理性',
            prop: 'planReasonableFlag',
            addDisplay: false,
            editDisplay: false,
            search: true,
            hide: true,
            showColumn: false,
            type: 'select',
            dicData: planReasonableDic,
          },
          {
            label: '合理性',
            prop: 'planReasonableName',
            minWidth: 110,
            slot: true,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '预警原因',
            prop: 'warningReason',
            minWidth: 220,
            overHidden: true,
            addDisplay: false,
            editDisplay: false,
          },
          {
            ...getSearchTimeConfig(),
            paramsKey: ["startTime", "endTime"],
          }
        ]
      },
    }
  },
  mounted () {

  },
  methods: {
    async handleExport () {
      if ((this.page.total || 0) < 1) {
        this.$message.warning('无数据可导出')
        return
      }
      this.exportLoading = true
      try {
        const params = this.formatParams(Object.assign({}, this.defaultParams, this.query))
        const res = await exportExcel(params)
        downloadXls(res.data, `智能计划协同_${Date.now()}.xlsx`)
        if (this.page.total > 10000) {
          this.$message.warning(`仅导出前 10000 条，共 ${this.page.total} 条`)
        } else {
          this.$message.success('导出成功')
        }
      } finally {
        this.exportLoading = false
      }
    },
    planReasonableLabel (value) {
      const item = this.planReasonableDic.find(item => String(item.value) === String(value))
      return item && item.label
    },
    planReasonableType (value) {
      const typeMap = {
        0: 'success',
        1: 'warning',
        2: 'danger',
      }
      return typeMap[String(value)] || 'info'
    },
    stockStatusType (value) {
      if (!value) {
        return 'info'
      }
      return String(value).indexOf('不足') > -1 ? 'danger' : 'success'
    }
  }
}
</script>
<style scoped lang="scss">
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;

  p {
    color: #000000;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    margin: 0;
  }
}

::v-deep .el-input__icon {
  line-height: 1 !important;
}
</style>
